import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Tengo que ser ciudadano para participar?',
    a: 'No. La participación comunitaria está abierta a vecinos, residentes, negocios locales y personas interesadas en el bienestar del vecindario.'
  }, {
    q: '¿Las reuniones son gratis?',
    a: 'Sí. Las reuniones comunitarias son gratuitas y están abiertas al público.'
  }, {
    q: '¿Puedo asistir aunque nunca haya ido?',
    a: 'Sí. Puedes asistir aunque sea tu primera vez. La página te ayuda a revisar la agenda, conocer la fecha y encontrar la información necesaria.'
  }, {
    q: '¿Puedo enviar comentarios sin asistir?',
    a: 'En muchos casos, sí. Puedes revisar las opciones disponibles para enviar comentarios por escrito o contactar al comité.'
  }, {
    q: '¿Qué temas se discuten?',
    a: 'Se pueden discutir temas como seguridad, tráfico, limpieza, vivienda, servicios, eventos, proyectos comunitarios, recursos locales y asuntos del vecindario.'
  }, {
    q: '¿Cómo me entero de próximas reuniones?',
    a: 'Puedes revisar el calendario, consultar la sección de próxima reunión o suscribirte a noticias y alertas.'
  }, {
    q: '¿Puedo ser voluntario?',
    a: 'Sí. Puedes revisar oportunidades de voluntariado, proyectos activos o contactar al comité para conocer cómo ayudar.'
  }, {
    q: '¿Dónde encuentro agendas y minutas?',
    a: 'En la sección de documentos, agendas y minutas. Ahí podrás consultar información de reuniones pasadas y próximas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-24 px-6 lg:px-8 bg-white" data-id="element-97">
      <div className="max-w-3xl mx-auto" data-id="element-98">
        <div className="text-center mb-12" data-id="element-99">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-100">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-101">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-xl overflow-hidden bg-white" data-id="element-102">
              <button onClick={() => toggleFaq(index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none focus:ring-2 focus:ring-sky focus:ring-inset" aria-expanded={openIndex === index} data-id="element-103">
                <span className="font-bold text-charcoal text-lg pr-4" data-id="element-104">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-sky shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-105" />
              </button>

              <div className={`grid transition-all duration-300 ease-in-out ${openIndex === index ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-106">
                <div className="overflow-hidden" data-id="element-107">
                  <div className="px-6 pb-6 text-gray-600 leading-relaxed border-t border-gray-50 pt-4" data-id="element-108">
                    {faq.a}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}